<div class="loading" *ngIf="show">
    <mat-progress-spinner [color]="'accent'" [mode]="'indeterminate'" [diameter]="100"></mat-progress-spinner>
</div>
